import gsap from 'gsap';
import SplitText from 'gsap/SplitText';

export default class Effects {
  constructor() {
    this.scroll = document.querySelector('.a-scroll');

    this.animate = {
      el: document.querySelectorAll('[data-animate]'),
    };
  }

  set = () => {
    this.animate.el.forEach((el) => {
      const object = el;
      object.style.visibility = 'hidden';
    });
  }

  inview = (el) => {
    const object = el;
    const { top, bottom } = el.getBoundingClientRect();

    if (top < window.innerHeight * 0.9 && bottom > 0) {
      if (el.trigger === undefined) {
        this.getAnimate(el);
        object.trigger = true;
      }
    }
  }

  animateStagger = (object) => {
    const split = new SplitText(object, { type: 'chars' });
    gsap.set(object, {
      delay: 0.2, visibility: 'visible',
    });
    gsap.fromTo(split.chars, {
      x: 25, opacity: 0,
    }, {
      x: 0, opacity: 1, duration: 2, stagger: 0.1, delay: 0.3,
    });
  }

  animateFade = (object) => {
    const split = new SplitText(object, { type: 'lines' });
    gsap.set(object, {
      delay: 0.2, visibility: 'visible',
    });
    gsap.fromTo(split.lines, {
      y: 50, opacity: 0,
    }, {
      y: 0, opacity: 1, duration: 2, stagger: 0.05, delay: 0.3, ease: 'expo.out',
    });
  }

  getAnimate = (el) => {
    const object = el;
    if (object.getAttribute('data-animate') === 'stagger') {
      this.animateStagger(object);
    }
    if (object.getAttribute('data-animate') === 'fade') {
      this.animateFade(object);
    }
  }

  run = () => {
    this.animate.el.forEach((el) => {
      this.inview(el);
    });
  }

  destroy() {
    gsap.ticker.remove(this.run);
  }

  init() {
    this.set();

    setTimeout(() => {
      gsap.ticker.add(this.run);
    }, 1000);
  }
}
